export default {
  home: "首页",
  hxys: "核心优势",
  jjfa: "解决方案",
  cpfw: "产品服务",
  xwzx: "新闻资讯",
  gywm: "关于我们",
  jrwm: "加入我们",
  banner: {
    text: "全场景 智互联",
    sub: "城市微场景运营服务商"
  }
};
